export default function (entries, classPrefix = 'form') {
	return `
	<div ${this.html.classAttr(classPrefix + '__fields')} ${this.html.dataAttr({fields: null})}>
		${this.loop(entries, (entry, name) => this.render('form/field', name, entry))}
	</div>
	`;
}
